<template>
  <meta-overlay v-model="isVisible" append-to-body close-by-mark transition="tra-scaleIn">
    <div class="real-name-bg" @click.stop>
      <div class="title">是否前往实名</div>
      <div class="content">请先进行实名认证再进行兑换</div>
      <div class="footer">
        <div class="close" @click="closeRealName">取消</div>
        <div class="confirm" @click="confirm">确定</div>
      </div>
    </div>
  </meta-overlay>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { showRealNameAuth } from "~/utils/jsb";

interface RealNameData {
  commodityId: string;
  gameId: string;
  propType: string;
}

const isVisible = ref<boolean>(false);
const data = ref<RealNameData | null>(null);

/**
 * @description 去实名认证
 * @return {void}
 */
const confirm = (): void => {
  const baseParams = JSON.parse(sessionStorage.getItem("baseParams") || "{}");

  if (isEnvModal() && baseParams.sdkVersion < 30103) {
    showRealNameAuth();
  } else {
    showRealNameAuth(
      13,
      JSON.stringify({
        props: {
          commodityid: data.value?.commodityId,
          gameid: data.value?.gameId,
          goods_type: data.value?.propType
        }
      })
    );
  }

  closeRealName();
  setTimeout(() => {
    baseParams.appVersionCode < 3800000 && navManager.back();
  }, 500);
};

/**
 * @description 关闭弹窗
 * @return {void}
 */
const closeRealName = (): void => {
  isVisible.value = false;
};

/**
 * @description 打开弹窗
 * @param {RealNameData} _data - 实名认证数据
 * @return {void}
 */
const open = (_data: RealNameData): void => {
  isVisible.value = true;
  data.value = _data;
};

defineExpose({
  open,
  close: closeRealName
});
</script>
<style scoped lang="scss">
.real-name-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .title {
    padding-top: 0.87rem;
    text-align: center;
    font-size: 0.69rem;
    font-weight: bold;
  }

  .content {
    color: #888;
    font-size: 0.58rem;
    padding: 0.65rem;
    text-align: center;
  }

  .footer {
    font-size: 0.7rem;
    font-weight: bold;
    border-top: 1px solid #e9e8e8;
    display: flex;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      color: #ff7210;
      border-left: 1px solid #e9e8e8;

      text-align: center;
    }

    .close {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      color: #000;
      border-right: 1px solid #e9e8e8;

      text-align: center;
    }
  }
}
</style>
